import React from 'react';

const CrossIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 0.375C6.07812 0.375 0.875 5.57812 0.875 12C0.875 18.4219 6.07812 23.625 12.5 23.625C18.9219 23.625 24.125 18.4219 24.125 12C24.125 5.57812 18.9219 0.375 12.5 0.375ZM19.25 13.3125C19.25 13.6219 18.9969 13.875 18.6875 13.875H14.375V18.1875C14.375 18.4969 14.1219 18.75 13.8125 18.75H11.1875C10.8781 18.75 10.625 18.4969 10.625 18.1875V13.875H6.3125C6.00313 13.875 5.75 13.6219 5.75 13.3125V10.6875C5.75 10.3781 6.00313 10.125 6.3125 10.125H10.625V5.8125C10.625 5.50313 10.8781 5.25 11.1875 5.25H13.8125C14.1219 5.25 14.375 5.50313 14.375 5.8125V10.125H18.6875C18.9969 10.125 19.25 10.3781 19.25 10.6875V13.3125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CrossIcon;
